// Source: https://rudrastyh.com/api/instagram-with-pure-javascript.html & https://humaan.com/blog/bigger-square-thumbnails-from-the-instagram-api/


import modals from './modals';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
dayjs.locale('nl');

function getJSON(url, callback) {

    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var res = xhr.responseText;
                callback(JSON.parse(res));
            } else { 
                console.error(xhr.statusText);
            }
        }
    }; 

    xhr.onerror = function (e) {
      console.error(xhr.statusText);
    }; 

    xhr.send(null);
}

modals.init();


// Blitskikker: 4639563558.8183fb1.aa6e2aef66484043a97fd2175e86cf3a
let num_photos = 4, // maximum 20
   container = document.querySelector('.js-insta'),
   scrElement = document.createElement('script');


window.processResult = function (data) {

    var i = 0;
   for (let x in data.data) {
       // set variables
       let d = new Date(data.data[x].timestamp),
           media_url = data.data[x].media_url,
           media_type = data.data[x].media_type,
           //date = distanceInWords(d, new Date().toISOString(), { locale: nl }),
           date = dayjs(d).format('D MMMM YYYY'),
           caption = data.data[x].caption,
           id = data.data[x].id,

           /********************************************************** */
           /******** seperate text from tags and add link to the tags */
           /******************************************************** */

           // add space before tags & create new string with all the tags
           seperatedTags = caption.replace(new RegExp('#', 'g'), ' #').substr(caption.indexOf("#")),
           // create array from string
           splittedTags = seperatedTags.split(' '),
           // loop over tags, create link and remove the hashtag from the URL
           tags = splittedTags.map(tag => `<a href="https://www.instagram.com/explore/tags/${tag}" target="_blank" rel="noopener">${tag}</a> `).join('').replace(new RegExp('/#', 'g'), '/'),
           // remove the hastags from the original caption
           text = caption.split('#')[0];

           if(media_type == "VIDEO") {
               var thumb = `<video class="insta-item__img" src="${media_url}" autoplay muted loop height="auto" width="100%">`;
               var full    = `<video src="${media_url}" controls height="auto" width="100%">`;
           } else {
               var thumb   = `<img class="insta-item__img" src="${media_url}">`;
               var full    = `<img src="${media_url}">`;
           }

           i++;

      if (i<=num_photos) {

       // set HTML
       container.innerHTML += `
           <li class="insta-item black">
               <a class="insta-item__link" data-modal="#insta_${id}" href="">
                   ${thumb}
               </a>
               <div class="insta-item__info modal" data-modal-window id="insta_${id}">
                   <div class="modal__img">
                       ${full}               
                   </div>
                   <div class="modal-content">
                       <a class="close" data-modal-close href="#">
                           <svg viewbox="0 0 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30" /></svg>
                       </a>
                       <div class="modal-content__info">
                           <p class="insta-item__text">${text}</p>
                           <p class="insta-item__date">${date}</p>
                       </div>
                       <div class="modal-content__cta">
                           <img src="/wp-content/themes/hm/img/hm.svg">
                           <div>
                               <h4>Follow Hollandse Meester?</h4>
                               <p>Go to <a href="https://www.instagram.com/hollandse_meester/" target="_blank" rel="noopener">@hollandse_meester</a></p>
                           </div>
                       </div>
                   </div>
               </div>
           </li>`
           ;

      }
   }
};

if (container) {
   getJSON('/instagram/instagram_data.json', function(data) {processResult(data) });
}